import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "truncate", "labelStyles"];
import { useMemo } from 'react';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import TruncatedPropertyLabel from './TruncatedPropertyLabel';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledLabel = _ref => {
  let {
      children,
      truncate,
      labelStyles
    } = _ref,
    domProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("dt", Object.assign({}, domProps, {
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/_jsx(Text, Object.assign({
      typography: "detail-100",
      color: "text-core-subtle",
      truncate: truncate,
      paddingBlock: "100"
    }, labelStyles, {
      children: children
    }))
  }));
};
export default function PropertyLabel({
  crmObject,
  hideDescription = true,
  property,
  propertyName,
  renderLabel,
  renderLabelBadge,
  truncateLabel,
  labelStyles
}) {
  const labelStr = useMemo(() => {
    if (renderLabel) {
      return '';
    }

    /**
     * Check if there is a custom translation key for @propertyName
     */
    const i18nPropertyKey = `frameworkAssetPreviewLib.propertyLabel.${crmObject.objectTypeId}.${propertyName}`;
    if (isValidI18nKey(i18nPropertyKey)) {
      return I18n.text(i18nPropertyKey);
    }

    /**
     * Check if there is a shared translation key for @propertyName
     */
    const i18nSharedKey = propertyName === 'hs_all_assigned_business_unit_ids' ? 'frameworkAssetPreviewLib.propertyLabel.shared.hs_all_assigned_business_unit_ids_buv2' : `frameworkAssetPreviewLib.propertyLabel.shared.${propertyName}`;
    if (isValidI18nKey(i18nSharedKey)) {
      return I18n.text(i18nSharedKey);
    }
    return property ? property.label : propertyName;
  }, [crmObject.objectTypeId, property, propertyName, renderLabel]);
  if (truncateLabel) {
    return /*#__PURE__*/_jsx(TruncatedPropertyLabel, {
      labelStr: labelStr,
      propertyName: propertyName,
      renderLabel: renderLabel,
      labelStyles: labelStyles
    });
  }
  const label = renderLabel ? renderLabel() : labelStr;
  const labelWithDescription = hideDescription ? label : /*#__PURE__*/_jsx(HelpIcon, {
    title: property === null || property === void 0 ? void 0 : property.description,
    size: "100",
    color: "text-tertiary-default",
    children: label
  });
  return /*#__PURE__*/_jsx(StyledLabel, {
    labelStyles: labelStyles,
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "100",
      "data-test-id": "property-label",
      "data-test-property-name": propertyName,
      alignItems: "center",
      children: [labelWithDescription, renderLabelBadge === null || renderLabelBadge === void 0 ? void 0 : renderLabelBadge()]
    })
  });
}